export const ViewerInstance = {
  viewer: undefined,
  setMounte(ref){
    this.viewer = ref
  }
}
export const useShowViewer = data =>
  ViewerInstance.viewer &&
  ViewerInstance.viewer.show &&
  ViewerInstance.viewer.show(data)


// WEBPACK FOOTER //
// ./src/components/Viewer/store.js